import { useTheme as useNextTheme } from "next-themes";

export type Theme = "light" | "dark" | "system";

export interface UseThemeReturn {
  theme: Theme | undefined;
  setTheme: (theme: Theme) => void;
  systemTheme: "light" | "dark" | undefined;
  resolvedTheme: "light" | "dark" | undefined;
}

export function useTheme(): UseThemeReturn {
  const { theme, setTheme, systemTheme, resolvedTheme } = useNextTheme();

  return {
    theme: theme as Theme | undefined,
    setTheme: setTheme as (theme: Theme) => void,
    systemTheme: systemTheme as "light" | "dark" | undefined,
    resolvedTheme: resolvedTheme as "light" | "dark" | undefined,
  };
}
